import axiosService from '@/api/common/adminAxios'

const api = {
  mapDataMngList: function(paramData) {
    return axiosService.post('admin/selectMapDataMng', paramData)
  },

  mapDataMngSidoList: function(paramData) {
    return axiosService.post('admin/selectMapDataMngSidoList', paramData)
  },

  mapDataMngSigunguList: function(paramData) {
    return axiosService.post('admin/selectMapDataMngSigunguList', paramData)
  },

  saveMapDataMng: function(paramData) {
    return axiosService.post('admin/saveMapDataMng', paramData)
  },

  insertMapDataMng: function(paramData) {
    return axiosService.post('admin/insertMapDataMng', paramData)
  },

  deleteMapDataMng: function(paramData) {
    return axiosService.post('admin/deleteMapDataMng', paramData)
  },

  mapTmeYearList: function(paramData) {
    return axiosService.post('admin/selectMapTmeList', paramData)
  },

  mapTmeNoList: function(paramData) {
    return axiosService.post('admin/selectMapTmeNoList', paramData)
  },

  mapDataSidoItmMng: function(paramData) {
    return axiosService.post('admin/selectMapDataSidoItmMng', paramData)
  },
}

export default api
